import React, { Suspense, useState, lazy, useRef } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Dialog,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import StatSkeleton from "../components/common/StatSkeleton";
import CreateVehicleModelTile from "../components/vehicle/model/CreateVehicleModelTile";
import VehicleModelsStats from "../components/vehicle/model/VehicleModelsStats";
import VehicleModelsDataGrid from "../components/vehicle/model/VehicleModelsDataGrid";
import VehicleModelTrimsTab from "../components/vehicle/model/VehicleModelTrimsTab";

const CreateVehicleTrim = lazy(() => import("../components/vehicle/model/CreateVehicleTrim"));

const VehicleModels = () => {
  const [expandedModel, setExpandedModel] = useState(null);
  const [trimDialogOpen, setTrimDialogOpen] = useState(false);
  const [trimDialogModel, setTrimDialogModel] = useState(null);
  const trimsRef = useRef(null);

  const handleViewTrims = (model) => {
    setExpandedModel((current) => {
      const newModel = current?.modelId === model.modelId ? null : model;

      if (newModel) {
        setTimeout(() => {
          trimsRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 120);
      }

      return newModel;
    });
  };

  const handleCollapseTrims = () => {
    setExpandedModel(null);
  };

  const handleOpenTrimDialog = (model = null) => {
    setTrimDialogModel(model);
    setTrimDialogOpen(true);
  };

  const handleCloseTrimDialog = () => {
    setTrimDialogOpen(false);
    setTrimDialogModel(null);
  };

  return (
    <Box className="fragmentContainer" sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
      {/* <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", md: "center" }}
        spacing={1.5}
      >
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700, color: "text.primary" }}>
            Vehicle Models
          </Typography>
        </Box>
      </Stack> */}

      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Suspense fallback={<StatSkeleton />}>
            <VehicleModelsStats />
          </Suspense>
        </Grid>

        <Grid size={{ xs: 12 }}>
          <CreateVehicleModelTile />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Card
            sx={{
              borderRadius: 3,
              border: "1px solid",
              borderColor: "divider",
              boxShadow: "0 12px 32px rgba(15, 23, 42, 0.06)",
              overflow: "hidden",
            }}
          >
            {/* <Box
              sx={{
                px: 3,
                py: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 1.5,
                borderBottom: "1px solid",
                borderColor: "divider",
              }}
            >
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                  Available vehicle models
                </Typography>
              </Box>
            </Box> */}
            <CardContent sx={{ p: { xs: 1.5, md: 2 }, "&:last-child": { pb: { xs: 1.5, md: 2 } } }}>
              <VehicleModelsDataGrid
                // tableTitle="Available Vehicle Models"
                onViewTrims={handleViewTrims}
                onAddTrim={handleOpenTrimDialog}
              />
            </CardContent>
          </Card>
        </Grid>

        {expandedModel && (
          <Grid size={{ xs: 12 }} ref={trimsRef}>
            <Card
              sx={{
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                boxShadow: "0 16px 36px rgba(15, 23, 42, 0.08)",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  px: 3,
                  py: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1.5,
                  backgroundColor: (theme) => alpha(theme.palette.secondary.main, 0.05),
                  borderBottom: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                    Trims for {expandedModel.name}
                  </Typography>
                </Box>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Button variant="outlined" size="small" onClick={handleCollapseTrims}>
                    Close
                  </Button>
                </Stack>
              </Box>
              <CardContent sx={{ p: { xs: 1.5, md: 2 } }}>
                <VehicleModelTrimsTab
                  modelId={expandedModel.modelId}
                  modelName={expandedModel.name}
                  tableSx={{ minHeight: 360 }}
                />
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>

      {trimDialogOpen && (
        <Dialog
          open
          onClose={handleCloseTrimDialog}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: {
              width: "90%",
              maxWidth: "700px",
              maxHeight: "80vh",
              overflowY: "auto",
            },
          }}
        >
          <Suspense fallback={<StatSkeleton />}>
            <CreateVehicleTrim
              modelId={trimDialogModel?.modelId}
              modelName={trimDialogModel?.name}
              toggleDialog={handleCloseTrimDialog}
            />
          </Suspense>
        </Dialog>
      )}
    </Box>
  );
};

export default VehicleModels;